/** Legal entity that owns and operates Radar (mother company), established in Romania. */
export const RADAR_LEGAL_ENTITY = "S.C. Aquivo Labs SRL";

export const RADAR_JURISDICTION = "Romania";

/** Romanian national law implementing the GDPR (EU) 2016/679. */
export const ROMANIA_GDPR_IMPLEMENTING_LAW =
  "Law no. 190/2018 on the implementation measures of Regulation (EU) 2016/679";

/** Romanian data protection supervisory authority (for complaints and oversight). */
export const ROMANIA_DPA_SHORT = "ANSPDCP";
export const ROMANIA_DPA_FULL_NAME =
  "Autoritatea Națională de Supraveghere a Prelucrării Datelor cu Caracter Personal";
export const ROMANIA_DPA_WEBSITE = "https://www.dataprotection.ro/";

/**
 * Optional public registry details (Romania). Set in the web app build as REACT_APP_PUBLIC_*.
 * Leave unset until you have real values — nothing is rendered when all are empty.
 */
export const COMPANY_REGISTERED_OFFICE =
  typeof process !== "undefined" && process.env.REACT_APP_PUBLIC_COMPANY_REGISTERED_OFFICE
    ? String(process.env.REACT_APP_PUBLIC_COMPANY_REGISTERED_OFFICE).trim()
    : "";
export const COMPANY_TRADE_REGISTER_ID =
  typeof process !== "undefined" && process.env.REACT_APP_PUBLIC_COMPANY_TRADE_REGISTER_ID
    ? String(process.env.REACT_APP_PUBLIC_COMPANY_TRADE_REGISTER_ID).trim()
    : "";
export const COMPANY_CUI =
  typeof process !== "undefined" && process.env.REACT_APP_PUBLIC_COMPANY_CUI
    ? String(process.env.REACT_APP_PUBLIC_COMPANY_CUI).trim()
    : "";

export function hasPublicCompanyRegistryDetails() {
  return Boolean(COMPANY_REGISTERED_OFFICE || COMPANY_TRADE_REGISTER_ID || COMPANY_CUI);
}
